import { render, staticRenderFns } from "./BulkShipmentViewPage.vue?vue&type=template&id=2a52d628&scoped=true&"
import script from "./BulkShipmentViewPage.vue?vue&type=script&lang=ts&"
export * from "./BulkShipmentViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkShipmentViewPage.vue?vue&type=style&index=0&id=2a52d628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52d628",
  null
  
)

export default component.exports